<template>
	<div class="container">
		<h2><strong>APP下载【仅限内部使用】</strong></h2>
		<div class="logo">
			<img class="img-fluid" :src="appLogo">
		</div>
		<div class="logo-desc">
			<span>{{appName}}</span>
		</div>
		<div class="version">
			版本：1.0 | 大小：5.5 mb | 更新时间：2022.11.13 23:47:14
		</div>
		<div>
<!--			<button type="button" class="btn btn-danger btn-lg" @click="download()">-->
<!--				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-display" viewBox="0 0 16 16">-->
<!--				  <path d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z"/>-->
<!--				</svg>-->
<!--				&nbsp;下载Windows版本-->
<!--			</button>-->
		</div>
		<div class="scan">
			<span>请使用手机扫描二维码下载</span>
		</div>
		<div class="qr_code">
			<vue-qr :logoSrc="appLogo" :text="domain" :size="280"></vue-qr>
		</div>
	</div>
</template>

<script>
	import vueQr from 'vue-qr';
	export default {
		components: {
			vueQr,
		},
		data() {
			return {
				domain: "",
				appLogo: "",
				appName: '', //app名字
				
			}
		},
		methods: {
			download(){
				window.location.href = gconf.download.window;
			}
		},
		created() {
			this.domain = window.location.href;

			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				if (!this.$route.params.channel) {
					this.$router.push('/shouye');
				} else {
					this.$router.push('/shouye/' + this.$route.params.channel);
				}
			}
			this.appName = gconf.appName;
			this.appLogo = gconf.appLogo;
		}
	}
</script>

<style scoped>
	.container {
		width: 750px;
		margin: auto;
	}

	h2 {
		margin-top: 20px;
	}

	.logo {
		margin-top: 10px;
	}

	.logo img {
		border-radius: 25px;
		width: 120px;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.logo-desc {
		font-size: 25px;
		font-weight: 700;
	}

	.logo-desc img {
		height: 25px;
		margin-right: 10px;
	}

	.version {
		margin-top: 10px;
		font-size: 16px;
		margin-bottom: 30px;
		color: #666666;
	}
	.scan{
		margin-top: 28px;
		margin-bottom: -4px;
		text-align: center;
		color: #2196F3;
		font-size: 14px;
		font-weight: 600;
	}
</style>
